/**
 * Header Navigation JavaScript
 * - Mobile menu toggle
 * - Mobile submenu accordions
 * - Cart count update
 * - Body scroll lock when menu open
 */

(function() {
  // Mobile menu toggle
  const menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const menuOverlay = document.querySelector('[data-mobile-menu]');
  const iconMenu = menuToggle?.querySelector('.icon-menu');
  const iconClose = menuToggle?.querySelector('.icon-close');

  if (menuToggle && menuOverlay) {
    menuToggle.addEventListener('click', function() {
      const isActive = menuOverlay.classList.toggle('active');
      
      if (isActive) {
        iconMenu.style.display = 'none';
        iconClose.style.display = 'block';
        document.body.style.overflow = 'hidden';
      } else {
        iconMenu.style.display = 'block';
        iconClose.style.display = 'none';
        document.body.style.overflow = '';
      }
    });

    // Close menu when clicking a link (not submenu toggles)
    const mobileLinks = menuOverlay.querySelectorAll('.mobile-nav-link:not([data-mobile-toggle])');
    mobileLinks.forEach(link => {
      link.addEventListener('click', function() {
        menuOverlay.classList.remove('active');
        iconMenu.style.display = 'block';
        iconClose.style.display = 'none';
        document.body.style.overflow = '';
      });
    });
  }

  // Mobile submenu toggles
  const submenuToggles = document.querySelectorAll('[data-mobile-toggle]');
  submenuToggles.forEach(toggle => {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      const submenuId = this.getAttribute('data-mobile-toggle');
      const submenu = document.querySelector(`[data-submenu="${submenuId}"]`);
      const parent = this.closest('.has-submenu');
      
      if (submenu) {
        const isExpanded = submenu.classList.toggle('expanded');
        parent.setAttribute('data-expanded', isExpanded);
      }
    });
  });

  // Update cart count from Shopify cart
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const badges = document.querySelectorAll('[data-cart-count]');
        badges.forEach(badge => {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }

  // Update on page load
  updateCartCount();

  // Listen for cart updates
  document.addEventListener('cart:updated', updateCartCount);
})();
